import { ModuleWithProviders } from '@angular/core';

import { RouterModule, Routes, } from '@angular/router';
import { StoreComponent } from './pages/store/store.component';
import { DetailsComponent } from './pages/details/details.component';
import { InventoryComponent } from './pages/inventory/inventory.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuardService } from './services/core/auth-guard.service';


const appRoutes: Routes = [
    { path: '', redirectTo: '/store', pathMatch: 'full' },    
    { path: 'store', component: StoreComponent },
    { path: 'details/:id', component: DetailsComponent },
    /*{ path: 'inventory', component: InventoryComponent, canActivate: [AuthGuardService] },*/
    { path: 'inventory', component: InventoryComponent},
    { path: 'login', component:  LoginComponent }
];

export const routes: ModuleWithProviders = RouterModule.forRoot(
    appRoutes, {
        // Tell the router to use the HashLocationStrategy.
        useHash: true,
        //enableTracing: true //only for testing
    }
);


// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/app.routers.ts